import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { useOffers } from "../../../../../stores/admin/offers/offersStore";

export default function offerByIntId (intId: number, user: string): ASTGeneratedOutput {
  const { isShowCommissions } = useOffers();

  const dataSet = {
    advertiser: [
      "landingParameters",
      "finance/payout/currency",
      "finance/payout/value"
    ],
    webmaster: [
      "finance/rate/currency",
      "finance/rate/value",
      "isAvailLimonadDomonetization",
      "webmasterJoinedState",
      "landing/trackingUrl",
      "landingParameters",
      "isPostbackEnable",
      "competitionPoint",
      "isAvailLimonadDomonetization"
    ],
    admin: [
      "finance/minimalCommission/currency",
      "finance/minimalCommission/value",
      "finance/payout/currency",
      "finance/payout/value"
    ].concat(isShowCommissions ? [
      "finance/rate/currency",
      "finance/rate/value",
      "minimalCommission/value",
      "minimalCommission/currency",
      "advertiserMinimalCommission/value",
      "advertiserMinimalCommission/currency"
    ] : [])
  };
  // @ts-ignore
  const params = { include: dataSet[user] };
  
  const gqlObject = {
    operation: "offerByIntId",
    
    fields: [
      "id",
      "intId",
      "slug",
      "createdAt",
      "type",
      "photoUrl",
      "landingUrl",
      "isApiAllowed",
      "vertical",
      "labels",
      {
        landing: [
          "cost",
          "currency",
          "preCost"
        ]
      },
      {
        logo: [
          "id",
          "url"
        ]
      },
      {
        detail: [
          "name",
          "description",
          "isInHouse",
          "rules"
        ]
      },
      {
        countries: [
          "id",
          "name",
          "alpha2",
          "alpha3"
        ]
      },
      {
        trafficTypes: [
          "id",
          "name"
        ]
      },
      {
        categories: [
          "id",
          "name"
        ]
      },
      {
        finance: [
          "withdrawType",
          "currency",
          "subGoalType",
          "duplicateTimeout",
          {
            holdTime: [
              "holdMinutes"
            ]
          }
        ]
      }
    ],
    
    variables: {
      intId: {
        type: "Int!",
        value: intId
      }
    }
    
  };
  
  return Generator.query(gqlObject, params);
}

